// src/access/kotaTuket.js
//
// KOTA TÜKETİMİNİ GÜVENLİ HALE GETİRİR (2026-08-22)
//
// SORUN: Sonuç kaydı ÖNCE yazılıyor, kota SONRA tüketiliyordu ve tüketim
// hatası dıştaki catch'te yutuluyordu. Yani kota düşmese bile kayıt kalıyor,
// katılımcı raporunu alıyordu — lisanslı üründe sessiz gelir kaçağı.
//
// ÖLÇÜLDÜ (TA / 3 Ego, 2026-08-22 21:40): aynı dakikada tamamlanan iki oturumdan
// yalnız biri kotaya işlendi. İkisinin de erişim kodu geçerliydi; ikinci işlem
// hata verip yutuldu. Sebep: TÜM tüketimler tek bir lisans belgesinin
// (accessCodes/<KOD>) sayaçlarını güncelliyor. Firestore'da tek belgeye
// sürdürülebilir yazma hızı ~1/sn'dir; atölyede 20 kişi aynı anda bitirince
// işlemler çakışır ve bir kısmı düşer.
//
// BU DOSYANIN YAPTIĞI (kapsamı sınırlı, faturalama mantığına dokunmaz):
//   1. Artan bekleme + rastgele sapma ile YENİDEN DENER — çakışma kaynaklı
//      düşmelerin çoğunu kurtarır.
//   2. Başarısızlığı konsola yazar.
//
// NEDEN KAYDA "işaretlenmedi" NOTU YAZILMIYOR: denendi ve kaldırıldı. Sonuç
// kayıtları kural gereği DEĞİŞMEZ (`allow update, delete: if false`), bu yüzden
// kaydın üstüne not yazmak her zaman başarısız olur. Onun yerine mutabakat
// dışarıdan yapılıyor: ~/SOMEREN_ARACLAR/kota_mutabakat/ — sonuç kaydı ile
// lisans tarafındaki kullanım kaydını BİREBİR eşleştirir. Sekme kapandığı için
// hiç kod çalışmayan durumu da yakalar; kayda not yazmak onu yakalayamazdı.
//   3. Katılımcı akışını KIRMAZ: hata fırlatmaz, durum döner. Katılımcı 60 soruyu
//      cevapladıktan sonra raporunu kaybetmemeli.
//
// KALICI ÇÖZÜM (yapılmadı, karar gerektirir): sayaçları tek belgede tutmayı
// bırakmak — tüketimleri salt-ekleme alt koleksiyonda saymak ya da parçalı
// sayaç kullanmak. Bu, 8 envanter + Antarktika + Meteors'un ortak lisans
// sistemini ilgilendirir.

const BEKLEME_MS = [400, 1200, 3000, 7000];

const uyu = (ms) => new Promise((r) => setTimeout(r, ms));

/**
 * @param {Function} tuket        completeInventoryUsage benzeri, parametreleri kapatılmış çağrı
 * @returns {Promise<{ok: boolean, sonuc?: any, hata?: Error, deneme: number}>}
 */
export async function kotayiTuketGuvenli(tuket) {
  let sonHata;
  for (let deneme = 0; deneme <= BEKLEME_MS.length; deneme++) {
    try {
      const sonuc = await tuket();
      if (deneme > 0) {
        console.warn(`[kota] ${deneme}. yeniden denemede tüketildi`);
      }
      return { ok: true, sonuc, deneme };
    } catch (err) {
      sonHata = err;
      // Kalıcı hatalarda yeniden denemek anlamsız: kod yok, hak yok, süresi dolmuş.
      const kod = String(err?.message || "");
      if (/NOT_FOUND|NOT_ALLOWED|EXPIRED|ALREADY_USED|NO_REMAINING_USES|INACTIVE|EMPTY_/.test(kod)) break;
      if (deneme < BEKLEME_MS.length) {
        await uyu(BEKLEME_MS[deneme] + Math.floor(Math.random() * 400));
      }
    }
  }

  console.error("[kota] tüketilemedi:", sonHata);
  return { ok: false, hata: sonHata, deneme: BEKLEME_MS.length + 1 };
}
